import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllAdminWalletUsers = createAsyncThunk(
  "Wallet/GetWalletUsersForAdmin",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetWalletUsersForAdmin`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Admin Wallet Users:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllWalletTransactionUserWise = createAsyncThunk(
  "Wallet/GetWalletTransactionUserWiseForAdmin",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetWalletTransactionUserWiseForAdmin`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Wallet Transaction User Wise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
